import React from "react";

const Footer = () => {
  return (
    <footer>
      <p>© 2026 Agustina Marini Finoquetto</p>
    </footer>
  );
};

export default Footer;
